<div [formGroup]="parentForm">
    <input id="{{'dateInput' + datepickerId}}" readonly [formControlName]="customControlName" (click)="activateDatepicker()" 
    [value]="parentForm.get(customControlName)!.value">
</div>
<div [id]="datepickerId" tabindex="10" (blur)="hideDatepicker($event)" [formGroup]="calendarForm" *ngIf="calendarForm">
    <div class="datepicker" *ngIf="datepickerActive">
        <div class="datepicker-header">
            <div class="arrow-container" (click)="backMonth()">
                <div id="left-arrow">
                </div>
            </div>
            <select id="monthSelector" formControlName="month" [compareWith]="compareValue" class="year-month-selector"
                (change)="monthChange()">
                <option *ngFor="let month of months" [ngValue]="month">{{month.name}}</option>
            </select>
            <select id="yearSelector" formControlName="year" class="year-month-selector" (change)="yearChange()">
                <option *ngFor="let year of years" [value]="year">{{year}}</option>
            </select>
            <div class="arrow-container" (click)="forwardMonth()">
                <div id="right-arrow"></div>
            </div>
        </div>
        <div>
            <table *ngIf="datepickerArray.length > 0">
                <tr class="week-row">
                    <th class="week-letter">L</th>
                    <th class="week-letter">M</th>
                    <th class="week-letter">M</th>
                    <th class="week-letter">J</th>
                    <th class="week-letter">V</th>
                    <th class="week-letter">S</th>
                    <th class="week-letter">D</th>
                </tr>
                <tr *ngFor="let week of datepickerArray">
                    <td *ngFor="let day of week" [ngClass]="{'day-box': day != null, 'empty-box': false}">
                        <div *ngIf="day != null" (click)="inputDate(day)" class="date-letter">
                            {{day.date()}}
                        </div>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</div>